LS.util.route({
	'$directory': {
		'$any': {
			'$segment': {
				'$any': {
					':preload': 'directory:preload',
					':load': 'directory',
					':unload': 'directory:unload'
				}
			}
		}
	}
});